var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailCardIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8189 39.8714C21.8189 39.8714 35.9874 32.7872 35.9874 22.1608V9.76338L21.8189 4.4502L7.65039 9.76338V22.1608C7.65039 32.7872 21.8189 39.8714 21.8189 39.8714Z",
    fill: "url(#paint0_linear_1433_48220)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3307 19.2119C31.0007 17.0998 30.0263 15.3566 28.4083 13.9866C26.7073 12.5178 24.6349 11.7827 22.1911 11.7827C19.7466 11.7827 17.6743 12.5094 15.9742 13.9612C14.3555 15.3494 13.3897 17.0998 13.0763 19.2119C13.0099 19.559 12.9766 19.8892 12.9766 20.2035C12.9766 21.5906 13.4305 22.8036 14.3395 23.8444C15.2472 24.8846 16.5271 25.6451 18.1791 26.1225V26.4957C18.1791 26.9574 18.3356 27.3458 18.6494 27.6591C18.9627 27.9731 19.3509 28.1468 19.8134 28.1795C20.2923 28.213 20.6468 28.1301 20.8782 27.932C21.2412 28.1956 21.646 28.3277 22.0921 28.3277C22.5049 28.3277 22.8851 28.2044 23.2313 27.9567C23.4628 28.1377 23.8009 28.213 24.2472 28.1795C24.7092 28.1301 25.0977 27.9525 25.4112 27.6473C25.7248 27.3403 25.8815 26.9575 25.8815 26.4957V26.2234C27.6646 25.7604 29.0437 24.9847 30.0185 23.8936C30.9596 22.854 31.4301 21.6242 31.4301 20.2035C31.4301 19.8892 31.3968 19.559 31.3307 19.2119ZM20.0611 21.6027C19.5655 22.173 18.9705 22.457 18.2776 22.457C17.5842 22.457 16.9897 22.1731 16.4943 21.6027C15.999 21.033 15.751 20.3431 15.751 19.5339C15.751 18.7254 15.999 18.0356 16.4943 17.4671C16.9897 16.8976 17.5842 16.6128 18.2776 16.6128C18.9705 16.6128 19.5655 16.8976 20.0611 17.4671C20.5566 18.0356 20.8049 18.7254 20.8049 19.5339C20.8048 20.3431 20.5566 21.0329 20.0611 21.6027ZM22.2156 24.8846C21.8027 24.8846 21.4972 24.7783 21.2995 24.5667C21.1836 24.4347 21.1263 24.2721 21.1263 24.0757C21.1263 23.7661 21.2458 23.456 21.4853 23.1449C21.7245 22.8355 21.9595 22.6803 22.1911 22.6803C22.4223 22.6803 22.6404 22.8514 22.8472 23.1958C23.0535 23.5384 23.1576 23.8642 23.1576 24.1753C23.1576 24.6489 22.8432 24.8846 22.2156 24.8846ZM27.6775 21.6027C27.1902 22.173 26.5919 22.457 25.8814 22.457C25.1883 22.457 24.5981 22.1731 24.111 21.6027C23.6233 21.033 23.3796 20.3431 23.3796 19.5339C23.3796 18.7254 23.6233 18.0356 24.111 17.4671C24.5981 16.8976 25.1883 16.6128 25.8814 16.6128C26.5919 16.6128 27.1904 16.8976 27.6775 17.4671C28.1642 18.0356 28.4083 18.7254 28.4083 19.5339C28.4084 20.3431 28.1642 21.0329 27.6775 21.6027Z",
    fill: "url(#paint1_linear_1433_48220)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4961 30.2554L31.4476 11.3039",
    stroke: "white",
    strokeWidth: 1.35368,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1433_48220",
    x1: 21.8189,
    y1: 4.4502,
    x2: 21.8189,
    y2: 39.8714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4790FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36FF3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1433_48220",
    x1: 22.2033,
    y1: 11.7827,
    x2: 22.2033,
    y2: 28.3277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.37
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailCardIcon8);
export default __webpack_public_path__ + "static/media/mail_card_icon8.d02be26cf8d681f81dfb84fad382a2b0.svg";
export { ForwardRef as ReactComponent };